module.exports = __webpack_public_path__ + "img/7.7a5526a3.png";